<template lang="pug">
  el-dialog(
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    class="custom-dialog-logout"
    top="5vh"
    :close-on-click-modal="false"
    title='Alterar Senha'
  )
    .conteudo
      .obs-alerta
        div A nova senha deve conter no mínimo <strong>8 caracteres</strong>, com ao menos <strong>1 letra maiúscula</strong>, <strong>1 numero</strong> e <strong>1 caractere especial.</strong>
      .senha-atual
        .label-input Senha Atual
        el-input(
          v-model="currentPassword"
          type="password"
          placeholder="Digite sua senha atual"
          show-password
        )
      .nova-senha
        .label-input Nova Senha
        el-input(
          v-model="newPassword"
          type="password"
          placeholder="Digite sua nova senha"
          show-password
        )

      .nova-senha
        .label-input Confirmar Nova Senha
        el-input(
          v-model="confirmNewPassword"
          type="password"
          placeholder="Digite sua nova senha"
          show-password
        )
      .btns
        el-button(type="primary" plain :disabled="!isPasswordValid" @click="alterar") Confirmar
        el-button(type="text" @click="dialogVisible = false") Cancelar
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import LoginGoogle from '../LoginGoogle.vue'

export default {
name: 'ModalLogout',

components: {
  LoginGoogle
},

data(){
  return{
    currentDialogWidth: this.calculateDialogWidth(),
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  }
},

mounted() {
  window.addEventListener('resize', this.handleResize);
},
beforeDestroy() {
  window.removeEventListener('resize', this.handleResize);
},

watch: {
  dialogVisible(newValue) {
    if (newValue) {
      this.currentPassword = ''
      this.newPassword = ''
    }
  }
},

computed: {
  ...mapGetters({
    getAlterarSenha: 'modais/getAlterarSenha'
  }),

  dialogWidth() {
    return this.currentDialogWidth;
  },

  dialogVisible: {
    get(){
      return this.getAlterarSenha
    },
    set(newValue){
      this.setAlterarSenha(newValue)
    }
  },

  isPasswordValid() {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return (
      this.currentPassword &&
      this.newPassword &&
      this.confirmNewPassword &&
      passwordRegex.test(this.newPassword) &&
      this.newPassword === this.confirmNewPassword
    )
  }
},

  methods: {
    ...mapMutations({
      setLoading: 'globais/setLoading',
      setAlterarSenha: 'modais/setAlterarSenha',
    }),
    ...mapActions({
      alterarSenha: 'usuario/alterarSenha'
    }),

    calculateDialogWidth() {
      return window.innerWidth < 576 ? '90%' : '490px'
    },
    handleResize() {
      this.currentDialogWidth = this.calculateDialogWidth()
    },
    alterar(){
      if (!this.isPasswordValid) {
        this.$message({
          message: 'A nova senha deve ter no mínimo 8 caracteres, incluindo 1 letra maiúscula, 1 número e 1 caractere especial.',
          type: 'error'
        });
        return;
      }
      if (this.confirmNewPassword !== this.newPassword) {
        this.$message({
          message: 'A confirmação da nova senha não corresponde à nova senha.',
          type: 'error'
        });
        return;
      }
      this.setLoading(true)
      this.alterarSenha({ senhaAntual: this.currentPassword, novaSenha: this.newPassword })
      .then(() => {
        this.setAlterarSenha(false)
        this.setLoading(false)
        this.$message({
          message: 'Sua senha foi alterada com sucesso!',
          type: 'success'
        })
      })
      .catch(err => {
        console.log(err)
        this.setLoading(false)
        this.$message({
          message: err.response.data,
          type: 'error'
        })
      })
    }
  },
}
</script>

<style lang="scss">
.custom-dialog-logout {
background: rgba(0, 0, 0, .6);

  .el-dialog {
    border-radius: 10px;

    .el-dialog__header{
      padding: 20px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #bcb8b8;

      .el-dialog__headerbtn{
        top: 19px;

        i{
          font-size: 30px;
        }
      }
    }

    .el-dialog__body{
      padding: 20px;

      .conteudo{
        .obs-alerta {
          padding: 15px 20px;
          box-sizing: border-box;
          border: 1px solid #F79009;
          border-radius: 6px;
          color: #F79009;
          background: #FFFCF5;
          font-size: 13px;
          margin: 20px 0;
          word-break: break-word;

          strong.sublinhado{
            text-decoration: underline;
          }
        }
        .label-input{
          text-align: left;
          font-size: 13px;
          font-weight: 300;
          color: #ffffffbd;
        }
        
      }
    }

    .el-dialog__footer {
     display: none;
    }
  }
}
</style>